<template>
    <div class="personal">
        <div class="container">
            <div class="left">
                <div class="leftContent">
                    <div class="leftTitle">个人信息</div>
                    <div class="logo">
                        <img :src="person.headimgurl"  v-if="person.wechat_bind == 1"/>
                        <img src="../../assets/person6.png"  v-else/>
                    </div>
                    <div class="text">
                        {{person.nickname}}
                    </div>
                    <div class="code">
                        <div class="bindCode">
                            <div class="bindPhone">
                                <div class="text">
                                    <img src="../../assets/information_phone.png" alt="">
                                    {{person.mobile}}
                                </div>
                                <!-- <div @click="updateBindPhone" v-if="person.sms.is_bind == 1"></div> -->
                                <!-- <div class="bind" @click="bindPhone">立即绑定</div> -->
                            </div>
                            <div class="bindWechat">
                                <div class="text">
                                    <img src="../../assets/information_wechat.png" alt="">
                                    {{person.nickname}}
                                </div>
                                <!-- <div class="bind bindRed" @click="unbondwechat" v-if="person.wechat.is_bind == 1">解除绑定</div> -->
                                <!-- <div class="bind" @click="bindwechat" >立即绑定</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="personContent clearfix" style="padding-left: 10px;">
                        <div class="personSwitch clearfix">
                            <div class="personSwitchTitle">公众号通知</div>
                            <el-switch 
                                v-model="accountFlag"
                                active-color="#B21111"
                                :active-value="true"
                                inactive-color="#ccc"
                                :inactive-value="false"
                                @change="acountChange">
                            </el-switch>
                        </div>
                        <div class="personSwitch clearfix">
                            <div class="personSwitchTitle">短信通知</div>
                            <el-switch 
                                v-model="msgFlag"
                                active-color="#B21111"
                                :active-value="true"
                                inactive-color="#ccc"
                                :inactive-value="false"
                                @change="msgChange">
                            </el-switch>
                        </div>
                    </div>
                </div>
                <div class="calendar">
                    <div class="addFiles">
                        <div class="name">当前档期</div>
                        <!-- @click="addPlanVisible = true" -->
                        <div class="addPlan">
                            <span class="icon"><i class="fa fa-pencil-square" aria-hidden="true"></i></span>
                            添加工作计划
                        </div>
                    </div>
                    <!-- v-model="calendarDate" -->
                    <el-calendar></el-calendar>
                </div>
            </div>
            <div class="right">
                <div class="person">
                    <div class="personTop clearfix">
                        <img src="../../assets/person1.png" class="personImg"/>
                        <div class="personTitle">密码</div>
                    </div>
                    <div class="personContent clearfix">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="!editPasswordFlag" @click="editPasswordFlag = !editPasswordFlag;">修改密码</el-button>
                        <div class="editInputBox" v-if="editPasswordFlag">
                            <div class="editInputBoxC clearfix">
                                <div class="editInputName">当前密码:</div>
                                <el-input type="password" class="editInput" v-model="passwordForm.password"></el-input>
                            </div>
                            <div class="editInputBoxC clearfix">
                                <div class="editInputName">新密码:</div>
                                <el-input type="password" class="editInput" v-model="passwordForm.new_password"></el-input>
                            </div>
                            <div class="editInputBoxC clearfix">
                                <div class="editInputName">确认新密码:</div>
                                <el-input type="password" class="editInput" v-model="passwordForm.confirm_password"></el-input>
                            </div>
                            <div class="clearfix">
                                <el-button class="funcPublicBtn funcPublicBtnChecked passwordSave" @click="modifyPassword('passwordForm')">保存</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="person">
                    <div class="personTop clearfix">
                        <img src="../../assets/person2.png" class="personImg">
                        <div class="personTitle">绑定手机</div>
                    </div>
                    <div class="personContent clearfix">
                        <div v-if="person.mobile_bind == 1">
                            <div class="personBind">
                                <div class="personBindTip">已绑定手机：{{person.mobile}}</div>
                                <div class="clearfix">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="updateBindPhone">更换手机号</el-button>
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="unbondBindPhone">解除绑定</el-button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <img src="../../assets/person5.png" class="personBindImg"/>
                            <div class="personBind">
                                <div class="personBindTip">手机号还未绑定，请立即绑定！</div>
                                <div class="clearfix">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="bindPhone">立即绑定</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="person">
                    <div class="personTop clearfix">
                        <img src="../../assets/person3.png" class="personImg"/>
                        <div class="personTitle">微信账号绑定</div>
                    </div>
                    <div class="personContent clearfix">
                        <div v-if="person.wechat_bind == 1">
                            <img :src="person.headimgurl" class="personBindImg"/>
                            <div class="personBind">
                                <div class="personBindTip personBindTipName">{{person.nickname}}</div>
                                <div class="clearfix">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="bindwechat">重新绑定微信</el-button>
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="unbondwechat">解除绑定</el-button>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <img src="../../assets/person6.png" class="personBindImg"/>
                            <div class="personBind">
                                <div class="personBindTip">微信号还未绑定，请立即绑定！</div>
                                <div class="clearfix">
                                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="bindwechat">立即绑定</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="person">
                    <div class="personTop clearfix">
                        <!-- <img src="../../assets/person3.png" class="personImg"/> -->
                        <div class="personTitle">微信二维码上传</div>
                    </div>
                    <div class="personContent  clearfix">
                        <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                            <img v-if="companyMess.picture" :src="companyMess.picture" class="uploadImage"/>
                            <img v-if="!companyMess.picture" src="/icon/plus-default@2x.png" class="uploadImageAdd"/>
                        </el-upload>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-dialog-drag title="修改密码" :visible.sync="dialogFormVisible" width="350px" @closed="closeDialogCallback('passwordForm')">
            <el-form :model="passwordForm" :label-position="labelPosition" :rules="rules" ref="passwordForm">
                <el-form-item label="原密码" :label-width="formLabelWidth" class="bottom" prop="password">
                    <el-input type="password" v-model="passwordForm.password"  size='medium'></el-input>
                </el-form-item>
                <el-form-item label="新密码" :label-width="formLabelWidth" class="bottom" prop="new_password">
                     <el-input type="password" v-model="passwordForm.new_password"  size='medium'></el-input>
                </el-form-item>
                <el-form-item label="确认密码" :label-width="formLabelWidth" class="bottom" prop="confirm_password">
                     <el-input type="password" v-model="passwordForm.confirm_password" size='medium'></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 20px">
                <el-button type="sumary" plain @click="modifyPassword('passwordForm')"  size='mini'>确 定</el-button>
                <el-button @click="dialogFormVisible = false, cancelEdit('passwordForm')" size='mini'>取 消</el-button>              
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="phoneDialog" class="eldialog" :modal="false"  width="350px" :title="changePhoneType == 1?'手机号绑定':'更换手机号'" custom-class="full_dialog">
            <div class="oldPhone" v-if="changePhoneType == 0">旧手机号：{{person.mobile}}</div>
            <div class="newPhone clearfix">
                <div class="phoneTitle">{{changePhoneType == 1 ? "手机号:":"新手机号:"}}</div>
                <el-input class="newPhoneNumber" placeholder="请输入手机号" v-model.number="changePhoneNumber"/>
            </div>
            <div class="codeBox clearfix">
                <div class="phoneTitle">验证码:</div>
                <div class="claearfix">
                    <el-input v-model="changePhoneCode" placeholder="验证码" class="codeInp"/>
                    <div class="getCode" @click="getCode">{{codeTip}}</div>
                </div>
            </div>
            <div class="clearfix changeBtnList">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="bindPhoneConfirm">立即绑定</el-button>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag title="关注公众号" class="eldialog wechatAcount" :modal="false" :visible.sync="followAcountDialog" width="300px">
            <img src="../../assets/acount.jpg" class="acountImg"/>
            <div class="wechatAcountTip">公众号通知需先关注公众号</div>
        </el-dialog>
        <wechat></wechat>
        <!-- <el-dialog v-dialog-drag title="微信授权" :visible.sync="wechatDialogVisible" class="eldialog" :model="false" width="300px">
        </el-dialog> -->
        <div class="wechatBox" v-show="wechatDialogVisible">
            <div class="wechatBg" @click="wechatDialogVisible=!wechatDialogVisible"></div>
            <div id="wechat"></div>
        </div>

    </div>
</template>

<script>
let time = null;
export default {
    data(){
        var validatePass1 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入原密码'));
            } else {
                // if (this.passwordForm.confirm_password !== '') {
                //     this.$refs.passwordForm.validateField('confirm_password');
                // }
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'));
            } else {
                if (this.passwordForm.confirm_password !== '') {
                    this.$refs.passwordForm.validateField('confirm_password');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入新密码'));
            } else if (value !== this.passwordForm.new_password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            labelPosition: 'left',
            formLabelAlign: {
                name: '',
                username: '',
                
                mobile: '',
                combination: '',
                occupation: '',
            },
            dialogFormVisible: false,
            followAcountDialog:false,
            passwordForm: {
                password: '',
                new_password: '',
                confirm_password: '',
            },
            formLabelWidth: '60px',
            rules: {
                password: [
                    { validator: validatePass1, trigger: 'blur' }
                ],
                new_password: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                confirm_password: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
            },
            editPasswordFlag:false,
            accountFlag:false,
            msgFlag:false,
            wechatDialogVisible:false,
            phoneDialog:false,
            changePhoneType:1,
            changePhoneNumber:"",
            changePhoneCode:"",
            getCodeFlag:true,
            countDown:60,
            codeTip:"获取验证码",
            changePhoneForm:{
                sub_type:"",
                mobile:""
            },
            bindPhoneForm:{
                mobile:"",
                code:""
            },
            person:{
                headimgurl:"",
                id: "",
                mobile: "",
                mobile_bind: 0,
                nickname: "",
                sms_type: 0,
                subscribe: 0,
                wechat_bind: 0,
                wechat_type: 0,
            },
            upload_data : {},
            oss : {
                host : "",
            },
            file_url : '',
            companyMess:{
                picture:"",
            }
        }
    },
    created(){
        this.getPersonMessage();
        let _this = this;
        window.wechatlogin = function(query){
            _this.wechatDialogVisible = false;
            _this.postFuncLoading("/erp/wx.bind",query,()=>{
				_this.tip("绑定成功","success")
                _this.getPersonMessage()
			},(error)=>{
				_this.tip(error.data.message,"warning")
            })
        }
    },
    methods:{
        handleSuccess(res) {
            this.companyMess.picture = res.data.base_url;
            this.$refs.upload_path.clearFiles();
            this.importFile();
        },
        beforeUpload(file) {
            this.file = file;
            return this.getOss();
        },
        importFile(){
            this.postFunc('erp/wx.code.upload',{file:this.companyMess.picture},res=>{
                this.tip('文件上传成功', 'success');
            })
        },
        getOss(){
            let self = this;
            return new Promise((resolve, reject) =>{
                window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                    operate_code : "shop-excel"
                }).then((response) => {
                    if(response.data.code == 0){
                        self.oss = response.data.data;
                        this.upload_data = {
                            name: self.file.name,
                            key : self.oss.dir + "${filename}",
                            policy : self.oss.policy,
                            OSSAccessKeyId : self.oss.accessid,
                            success_action_status : "200",
                            callback : self.oss.callback,
                            signature : self.oss.signature,
                            'Cache-Control' : self.oss.cache_control,
                        }
                        resolve();
                    }
                }).catch(()=>{
                    reject();
                })
            })
        },
        bindPhoneConfirm(){
            this.$confirm('是否确认绑定?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.bindPhoneForm.mobile = this.changePhoneNumber;
                this.bindPhoneForm.code = this.changePhoneCode;
                this.postFuncLoading("/erp/mobile.bind",this.bindPhoneForm,()=>{
                    this.tip('绑定成功','success');
                    this.getPersonMessage()
                    this.phoneDialog = false;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        getCode(){
            if(this.changePhoneNumber == ""){
                this.tip("请输入手机号","warning")
                return;
            }else{
                if(this.getCodeFlag){
                    this.changePhoneForm.sub_type = this.changePhoneType;
                    this.changePhoneForm.mobile = this.changePhoneNumber;
                    this.postFuncLoading("/erp/send.valid.code",this.changePhoneForm,()=>{
                        this.getCodeFlag = false;
                        this.countDown --;
                        this.codeTip = this.countDown + "s后获取"
                        time = setInterval(()=>{
                            this.countDown --;
                            this.codeTip = this.countDown + "s后获取";
                            if(this.countDown <= 0){
                                this.getCodeFlag = true;
                                this.codeTip = "获取验证码";
                                clearInterval(time);
                                time = null;
                            }
                        },1000)
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            }
        },
        updateBindPhone(){
            this.phoneDialog = !this.phoneDialog;
            this.changePhoneType = 0;
        },
        unbondBindPhone(){
            this.postFuncLoading('erp/mobile.unbind',{},()=>{
                 this.tip('解绑成功','success');
                 this.getPersonMessage();
            })
        },
        bindPhone(){
            this.phoneDialog = !this.phoneDialog;
            this.changePhoneType = 1;
        },
        unbondwechat(){
            this.$confirm('是否确认解绑?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFuncLoading("/erp/wx.unbind",{},()=>{
                    this.tip('解绑成功','success');
                    this.getPersonMessage()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        getPersonMessage(){
            this.postFunc("/erp/user.center",{},response=>{
                this.person = response.data.data;
                this.accountFlag = this.person.wechat_type == 1 ? true:false;
                this.msgFlag = this.person.sms_type == 1 ? true:false;
                this.companyMess.picture = this.person.wx_file
                if(this.person.wechat_bind == 1 && this.person.subscribe == 0 && this.person.wechat_type == 1){
                    this.followAcountDialog = true;
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        acountChange(e){
            this.postFunc("/erp/user.notice.setting",{type:"wechat",module:"all",status:e?1:0},()=>{
                this.tip("设置成功","success")
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        msgChange(e){
            this.pl(e)
            this.postFunc("/erp/user.notice.setting",{type:"sms",module:"all",status:e?1:0},()=>{
                this.tip("设置成功","success")
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        bindwechat(){
				this.wechatDialogVisible = true;
				// let url = location.href;
                // url = encodeURI(url.substring(0,url.indexOf('.com')+4))
                let bind_redirect_uri = location.origin + "/wechatbind";
                this.postFunc("/erp/wx.oauth",{redirect_uri:bind_redirect_uri,is_redirect_uri:true},res=>{
                    let token = localStorage.getItem("dw_erp_user_token")
                    new WxLogin({
                        self_redirect:true,
                        id:"wechat", 
                        appid: "wxdca847fd7ee08910", 
                        scope: "snsapi_login", 
                        redirect_uri: res.data.data,
                        state: token.substr(0,24),
                        style: "",
                        href: ""
                    });
                },error=>{
                    this.tip(error.data.message,"warning")
                })
			},
        modifyPassword(passwordForm){
            if(this.passwordForm.password == ''){
                this.tip("当前密码不能为空","warning")
                return;
            }
            if(this.passwordForm.new_password == ''){
                this.tip("新密码不能为空","warning")
                return;
            }
            if(this.passwordForm.confirm_password == ''){
                this.tip("确认新密码不能为空","warning")
                return;
            }
            if(this.passwordForm.new_password != this.passwordForm.confirm_password){
                this.tip("两次输入密码不一致","warning")
                return;
            }
            this.postFunc("/erp/user.reset.password",this.passwordForm,response=>{
                if(response.data.code == 0){
                    this.dialogFormVisible = false
                    this.$message({
                        message: '密码修改成功',
                        type: 'success'
                    });
                    setTimeout(() => {
                        localStorage.removeItem("dw_erp_user_id");
                        localStorage.removeItem("dw_erp_user_name");
                        localStorage.removeItem("dw_erp_user_username");
                        localStorage.removeItem("dw_erp_all_customer");//added by xiong 超级管理员权限
                        localStorage.removeItem("dw_erp_user_token");
                        localStorage.removeItem("dw_erp_power_code");
                        localStorage.removeItem("dw_erp_company_name");
                        localStorage.removeItem("dw_erp_category");
                        localStorage.removeItem("dw_erp_board");
                        localStorage.removeItem("dw_erp_enable_config");
                        this.$router.replace("/login");
                    }, 1000);
                }     
            },error=>{
                this.tip(error.data.message,"warning")
            })
            // this.$refs[passwordForm].validate((valid) => {
            //     if (valid) {
            //     } else {
            //         return false;
            //     }
            // })            
        },
        submitForm(){
            if(this.formLabelAlign.name === ''){
                this.$message({
                    message: '请填写姓名',
                    type: 'warning'
                });
                this.$refs.name.focus();
                return
            }
            var params = {};
            params.name = this.formLabelAlign.name;
            params.combination = this.formLabelAlign.combination;
            params.occupation = this.formLabelAlign.occupation;
            this.postFunc("/erp/user.edit",params,()=>{
                this.$message({
                    message: '修改成功',
                    type: 'success'
                });
                this.getPersonal();
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        getPersonal(){
            this.postFunc("/erp/user.info",{},response=>{
                if(response.data.code == 0){
                    this.formLabelAlign = response.data.data;
                }
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        disabled(e){
            e.target.blur();
        },
        cancelEdit(formName){
            this.$refs[formName].resetFields();
        },
        closeDialogCallback(formName){
             this.$refs[formName].resetFields();
        }
    },
    watch:{
        phoneDialog:function(val){
            if(!val){
                this.changePhoneForm = {sub_type:"",mobile:""};
                this.bindPhoneForm = {mobile:"",code:""};
            }
        }
    },
    components:{
        'wechat': {
            render(createElement) {
                return createElement(
                'script',
                {
                attrs: {
                type: 'text/javascript',
                src: "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js",
                },
                },
                );
            },
        }
    }
}
</script>

<style lang="scss" scoped>
.wechatBox{width:100%;height: 100vh;position: fixed;top:0;left:0;z-index:10;}
.wechatBg{width:100%;height: 100%;background-color: #000;opacity: 0.4;position: absolute;top:0;left:0;}
#wechat{width:300px;height:400px;position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;background-color: #fff;}

.bottom{margin-top: 15px;}
.personal{width: 100%;height: 100%;padding: 5px 0 0 5px;background: #eee;}
.container{height: 100%;display:flex;flex-direction: row;margin: auto;box-shadow: 0 0 5px #ccc;}
.container .left{background: #fff;flex-basis: 290px;margin-right: 15px;padding: 0 15px 15px 15px 15px;}

.left {min-width: 290px;max-width: 290px;background: white;padding: 0 15px 15px 15px;margin-right: 15px;
    .calendar {padding: 20px 15px;margin: 15px 0;padding: 10px;border-radius: 6px; box-shadow: 1px 1px 3px #a5a5a5;-webkit-box-shadow: 1px 1px 3px #a5a5a5;}
    .leftTitle {height: 45px;line-height: 45px;border-bottom: 1px solid #f2f2f2;color: #484a4d;font-weight: bold;font-size: 18px;}
    .logo {padding: 20px 0 12px 0;
        img {width: 110px;height: 110px;border-radius: 50%;}.text{font-weight: 600;padding: 0 0 10px 0;}
    }
    .code {padding: 10px;font-size: 14px;
        img {border-radius: 3px; width: 60px; height: 60px; box-shadow: 1px 1px 3px #a5a5a5; -webkit-box-shadow: 1px 1px 3px #a5a5a5;-moz-box-shadow: 1px 1px 3px #a5a5a5;}
    }
    .bindCode {text-align: left;
        .bindWechat { cursor: pointer;padding: 8px 0;display: flex;align-items: center;
            .text {flex-grow: 2;display: flex;align-items: center;padding: 0;
                img {width: 17px;height: 17px;margin-right: 10px;}
            }
        }
    }
    .bind { width: 80px;padding: 3px 0;text-align: center;color: white;background: #409EFF;border-radius: 3px;font-size: 12px;}
    .bindRed { background: #c85151;}
    .bindPhone {cursor: pointer;padding: 8px 0;display: flex;align-items: center;
        .text {flex-grow: 2;display: flex;align-items: center;padding: 0;
            img {width: 17px;height: 17px; margin-right: 10px;}
        }
        .bind {width: 80px;padding: 3px 0;text-align: center;color: white;background: #409EFF;border-radius: 3px;font-size: 12px; }
        .bindRed {background: #c85151;}
    }
    .addFiles { margin-bottom: 25px; display: flex;align-items: center;}
    .addFiles .name {font-size: 15px;font-weight: 600;flex-grow: 2;text-align: left;}
    .addFiles .addPlan {font-size: 14px;cursor: pointer;
        .icon {font-size: 18px;}
    }
    .addFiles .addPlan:hover {color: #409EFF;}
}
// 公众号
.personContent{padding-left:10px;}
.personSwitch{margin-bottom:10px;}
.personSwitchTitle{float: left;font-size: 14px;margin-right:70px;width:70px;text-align: left;}

.container .right{background: #fff;flex: 1;overflow: hidden;}

.title{font-size: 18px;font-weight: 700;height: 65px;line-height: 65px;}
.form_box{flex:1;width: 400px;box-shadow: 0 0 8px #aaa;padding: 20px; border-radius: 5px;}
.btn_item{margin-top:40px;}
.person{min-height:100px;padding:15px 10px 5px 10px;border-bottom:5px solid #eee;}
.personImg{display: block;float: left;width:20px;margin-right:5px;}
.personTitle{font-size: 14px;float: left;font-weight: 600;}
.personContent{padding:10px 0;padding-left:30px;}
.editInputBox{width:300px;}
.editInputBoxC{width:300px;margin-bottom:10px;}
.editInputName{float: left;font-size: 14px;height:30px;line-height: 30px;padding-right:5px;width:100px;text-align: right;box-sizing: border-box;}
.editInput{float: left;width:200px;}
.passwordSave{float: right;margin-right:0;}
.personBindImg{width:70px;display: block;float: left;margin-right:25px;}
.personBind{float: left;}
.personBindTip{font-size: 14px;color: #777;margin-bottom:20px;}
.personBindTipName{text-align: left;}
.personSwitch{margin-bottom:10px;}
.personSwitchTitle{float: left;font-size: 14px;margin-right:10px;width:70px;}
.switchC{float: left;}
.funcPublicBtn{line-height: 27px;font-size: 12px;height: 27px;}
.newPhone{width:230px;margin: auto;}
.phoneTitle{font-size: 14px;float: left;margin-right:10px;line-height: 25px;width:60px;text-align: right;}
.newPhoneNumber{width:160px;float: left;}
.codeBox{width:230px;margin: auto;margin-top:10px;}
.codeInp{width:90px;float: left;margin-right:0px;}
.getCode{width:70px;line-height: 23px;color:#b21111;box-sizing: border-box;height: 25px;border-radius: 3px;float: left;font-size: 12px;border:1px solid #b21111;cursor: pointer;}
.el-dialog__body{padding:10px;}
.changeBtnList{width:190px;margin:auto;margin-top:10px;}
.changeBtnList .funcPublicBtn{float: right;margin-right:0px;}
.oldPhone{width:230px;margin: auto;text-align: left;margin-bottom:10px;}
.acountImg{display: block;width:200px;margin: auto;}
.wechatAcountTip{font-size: 16px;color:#333;padding:10px 0;letter-spacing: 1px;font-weight: 600;}
// .companyContent{float: left;font-size: 14px;height:30px;line-height: 30px;}
.companySetBoxLogo{height:110px;}
.upload-demo{width:100px;}
.uploadImage{width:100px;height:100px;}
.uploadImageAdd{width:35px;height: 35px;margin:auto;margin-top:32.5px;}
.companySetBox .el-upload-dragger {
    width: 102px;
    height: 102px;
}
</style>